/**
 * JavaScript Utility - array/clean
 * @author 서명환 <mhseo@ulalalab.com>
 */
import isEmpty from '../isEmpty';

function clean(array = []) {
  return array.filter(item => !isEmpty(item));
}

export default clean;
